import React, { useMemo, useEffect, useState, forwardRef, useImperativeHandle } from "react";
import EpsInstructionsAccordion from "../../../components/Portfolios/EpsInstructionsAccordion";
import { getActiveColorStyle } from "../../../utils/colorUtils";
import { Card } from "reactstrap";
import { useUpdateCalculus } from "../../../api/calculuses/service";

const EpsInstructionsTab = forwardRef(({ data, id }, ref) => {

  const [isLightTheme, setIsLightTheme] = useState(false);
  const [formData, setFormData] = useState({
    calculus_instruction: {
      payment_instructions: {
        pages: []
      }
    }
  });
  useEffect(() => {
    const checkTheme = () => setIsLightTheme(document.body.classList.contains('white-content'));
    checkTheme();
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  // Initialize form data from props
  useEffect(() => {
    if (data?.calculus_instruction) {
      setFormData({
        calculus_instruction: {
          payment_instructions: {
            pages: data?.calculus_instruction?.payment_instructions?.pages || []
          }
        }
      });
    }
  }, [data?.calculus_instruction]);

  const activeColorStyle = useMemo(() => getActiveColorStyle(), []);
  const cardChromeStyle = useMemo(() => ({
    boxShadow: 'none',
    border: isLightTheme ? '1px solid rgba(0, 0, 0, 0.12)' : '1px solid rgba(255, 255, 255, 0.08)'
  }), [isLightTheme]);
  const inputStyle = useMemo(() => ({ backgroundColor: 'transparent' }), []);

  const updateMutation = useUpdateCalculus();

  useImperativeHandle(ref, () => ({
    handleSave: async () => {
      // Send calculus_instruction shape directly to calculus API
      const payload = {
        calculus_instruction: formData.calculus_instruction || {}
      };
      await updateMutation.mutateAsync({ id, data: payload });
      return { success: true };
    }
  }));

  return (
    <Card className="p-3">
      <EpsInstructionsAccordion
        instructions={formData.calculus_instruction?.payment_instructions?.pages || []}
        onChange={(next) => setFormData(prev => ({
          calculus_instruction: {
            payment_instructions: {
              pages: next
            }
          }
        }))}
        readOnly={false}
        requireOverride={true}
        activeColorStyle={activeColorStyle}
        isLightTheme={isLightTheme}
        cardChromeStyle={cardChromeStyle}
        inputStyle={inputStyle}
      />
    </Card>
  );
});

export default EpsInstructionsTab;


